import { Case } from '@/entities/cases'
import { useStyles } from './styles'
import { LootBoxOrder } from '@/entities/cases'
import CaseCard from '@/features/cardCase'

type CaseListProps = {
  data: Case[]
  sortBy?: 'id' | 'name' | 'idreverse' | 'isactive' | 'isactiveidreverse'
}

enum GetPlatformByKind {
  'gamed' = 1,
  'cs2' = 4,
  'dota2' = 2,
  'cargo' = 3,
}

export const CaseList = (props: CaseListProps) => {
  const { data, sortBy = 'name' } = props
  const { classes } = useStyles()

  const sortedData = [...data].sort((a, b) => {
    if (sortBy === 'name') {
      const orderA = LootBoxOrder[a.name as keyof typeof LootBoxOrder] ?? Infinity
      const orderB = LootBoxOrder[b.name as keyof typeof LootBoxOrder] ?? Infinity
      return orderA - orderB
    }

    if (sortBy === 'id') {
      return a.id - b.id
    }
    if (sortBy === 'idreverse') {
      return b.id - a.id
    }
    if (sortBy === 'isactive') {
      if (a.active !== b.active) {
        return b.active ? 1 : -1
      }

      if (a.active && b.active) {
        const orderA = LootBoxOrder[a.name as keyof typeof LootBoxOrder] ?? Infinity
        const orderB = LootBoxOrder[b.name as keyof typeof LootBoxOrder] ?? Infinity
        return orderA - orderB
      }

      return a.id - b.id
    }
    if (sortBy === 'isactiveidreverse') {
      if (a.active === b.active) {
        return b.id - a.id
      }
      return b.active ? 1 : -1
    }

    return 0
  })

  return (
    <div className={classes.root}>
      {sortedData.map((item, index) => (
        <CaseCard
          id={item.id}
          boxDescription={item.description}
          kind={item.kind}
          key={index}
          caseName={item.name}
          price={item.price_keys}
          platformName={GetPlatformByKind[item.kind]}
          isAvailable={item.active}
          expiredAt={item.expired_at}
        />
      ))}
    </div>
  )
}
